import { render, staticRenderFns } from "./AlbumCreateContainer.vue?vue&type=template&id=ba20ff76&scoped=true"
import script from "./AlbumCreateContainer.vue?vue&type=script&lang=js"
export * from "./AlbumCreateContainer.vue?vue&type=script&lang=js"
import style0 from "./AlbumCreateContainer.vue?vue&type=style&index=0&id=ba20ff76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba20ff76",
  null
  
)

export default component.exports